import { ReactTable } from './ReactTable.jsx';

export default ReactTable;
